import Applications from 'components/global/Applications';

const LenderPortfolio = () => <Applications />;

export default LenderPortfolio;
